// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#font-picker .dropdown-button {
  background: #e8e8e8;
}
`, "",{"version":3,"sources":["webpack://./src/pages/postGenerator.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB","sourcesContent":["#font-picker .dropdown-button {\n  background: #e8e8e8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
